const bagApiKey = import.meta.env.VITE_BAG_API_KEY;

if (!bagApiKey) {
  console.error('Missing BAG API key (VITE_BAG_API_KEY)');
  throw new Error('Missing BAG API key (VITE_BAG_API_KEY)');
}

const BAG_API_BASE = 'https://api.bag.kadaster.nl/lvbag/individuelebevragingen/v2';

/**
 * Fetch BAG object by endpoint and id
 * @param {string} endpoint - e.g. 'adressen'
 * @param {string} id - e.g. adres id
 * @returns {Promise<any>}
 */
export async function fetchBagObject(endpoint, id) {
  const url = `${BAG_API_BASE}/${endpoint}/${id}`;
  const response = await fetch(url, {
    headers: {
      'X-Api-Key': bagApiKey
    }
  });
  if (!response.ok) {
    throw new Error(`BAG API error: ${response.status}`);
  }
  return response.json();
}

// Specifieke helper voor adressen
export async function fetchBagAdres(adresId) {
  return fetchBagObject('adressen', adresId);
}

/**
 * Zoek adressen via de BAG API
 * @param {string} query - zoekterm (straat, postcode, huisnummer, etc.)
 * @returns {Promise<Array<{ id: string, label: string }>>}
 */
export async function searchBagAdressen(query) {
  if (!query || query.length < 4) return [];
  const url = `${BAG_API_BASE}/adressen?zoek=${encodeURIComponent(query)}`;
  const response = await fetch(url, {
    headers: {
      'X-Api-Key': bagApiKey
    }
  });
  if (!response.ok) {
    throw new Error(`BAG API search error: ${response.status}`);
  }
  const data = await response.json();
  // BAG API geeft een array van adressen terug onder _embedded.adressen
  return (
    data?._embedded?.adressen?.map((adres) => ({
      id: adres.identificatie, // BAG-adres-ID
      label: adres.adres?.volledigAdres || adres.adresregel || 'Onbekend adres'
    })) || []
  );
} 